import {IrisMessenger} from "@/iris-messenger/classes.js";

export let hasIrisMessengerMixin = {
    data () {
        return {

            GlobalMessenger: new IrisMessenger(),
        }
    },
}